export const lang: any = {
  get: (string: string, parameters: string[]) => {
    switch (string) {
      case 'MAX_ORDER_QUANTITY_REACHED_SUMMARY':
        return `Maksimal ordremængde nået.`;
      case 'MAX_ORDER_QUANTITY_REACHED_DETAILS':
        return `Du kan ikke bestille mere end ${parameters && parameters.length > 0 ? parameters[0] : ''
          } enheder af dette produkt.`;
      case 'YOU_CAN_ADD_MORE':
        return `Du kan tilføje ${parameters[0]} mere`;
      case 'QUANTITY_EXCEEDS_STOCK':
        return `Antal overstiger tilgængelig beholdning. Kun ${parameters && parameters.length > 0 ? parameters[0] : '0'} tilgængelige.`;
      case 'ORDER_BEFORE_CUTOFF_AND_KITCHEN_PREPARES':
        return `Bestil før kl. ${parameters && parameters.length > 0 ? parameters[0] : ''} for at få tidligere levering`;
      case 'ADDON_SHOW_MORE_COUNT':
        return `Vis ${parameters?.[0] ?? ''} mere`;
      case 'ADDON_SHOW_MORE_GROUPS_ONE':
        return `Vis ${parameters?.[0] ?? ''} gruppe mere`;
      case 'ADDON_SHOW_MORE_GROUPS_MANY':
        return `Vis ${parameters?.[0] ?? ''} grupper mere`;
      case 'FIRST_AVAILABLE':
        return `Tidigst tilgængelig ${parameters && parameters.length > 0 ? parameters[0] : ''}`;
      default:
        return '';
    }
  },
  CORPORATE_CATERING: 'Firmacatering',
  GO_TO_CHECKOUT: 'Gå til kassen',
  FIRST_AVAILABLE: 'Tidigst tilgængelig',
  SELECT_PICKUP_DATE: 'Vælg afhentningsdato',
  MAX_ORDER_QUANTITY_REACHED_SUMMARY: 'Maksimal ordremængde nået.',
  MAX_ORDER_QUANTITY_REACHED_DETAILS: 'Du kan ikke bestille mere end den tilladte mængde af dette produkt.',
  ADD_TO_CART: 'Tilføj til kurv',
  MORE_INFO: 'Mere info',
  COMPLETE_YOUR_ORDER: 'Fuldfør din ordre',
  CHECKOUT_SUBTITLE: 'Følg trinnene nedenfor for at afslutte dit køb',
  PICKUP_INSTRUCTIONS_LABEL: 'Afhentningsinstruktioner',
  DELIVERY: 'Levering',
  INFORMATION: 'Information',
  SUMMARY: 'Resumé',
  PAYMENT: 'Betaling',
  DELIVERY_DETAILS: 'Leveringsdetaljer',
  CHOOSE_DELIVERY_METHOD_AND_TIME: 'Vælg leveringsmetode, dato og tidspunkt',
  SELECTED_DELIVERY_METHOD: 'Valgt leveringsmetode',
  PICKUP: 'Afhentning',
  COLLECT_FROM_LOCATION: 'Hent fra vores lokation',
  DELIVER_TO_ADDRESS: 'Lever til din adresse',
  DELIVERY_LOCATION: 'Leveringsadresse',
  DELIVERY_LOCATION_PROMPT: 'Hvor skal vi levere din ordre?',
  SELECT_DELIVERY_LOCATION: 'Vælg leveringssted',
  CONNECTED_COMPANY: 'Tilknyttet virksomhed',
  LOCATIONS_NAME: 'Stednavn',
  STREET_ADDRESS: 'Gadeadresse',
  CITY: 'By',
  POSTAL_CODE: 'Postnummer',
  FLOOR: 'Etage',
  DELIVERY_ROOM: 'Leveringsrum',
  DOOR_CODE: 'Dørkode',
  DATE_AND_TIME: 'Dato og tid',
  PICKUP_DATE_AND_TIME: 'Afhentningsdato og tid',
  DELIVERY_DATE_AND_TIME: 'Leveringsdato og tid',
  SELECT_DATE: 'Vælg dato',
  SELECT_TIME: 'Vælg tid',
  ADDITIONAL_INSTRUCTIONS: 'Yderligere instruktioner',
  COMMENT_TO_RESTAURANT: 'Kommentar til restauranten',
  COMMENT_TO_RESTAURANT_PLACEHOLDER:
    'Har du noget, du gerne vil informere om?',
  CONTINUE_TO_INFORMATION: 'Fortsæt til dine oplysninger',
  YOUR_INFORMATION: 'Dine oplysninger',
  CONTACT_BILLING_DETAILS: 'Kontakt og faktureringsoplysninger',
  CONTACT_INFO: 'Kontaktoplysninger',
  CONTACT_INFO_DESCRIPTION:
    'Vi vil bruge disse oplysninger til at kontakte dig om din ordre.',
  FIRST_NAME: 'Fornavn',
  FIRST_NAME_REQUIRED: 'Fornavn er påkrævet.',
  LAST_NAME: 'Efternavn',
  EMAIL_ADDRESS: 'E-mailadresse',
  PHONE_NUMBER: 'Telefonnummer',
  ADDITIONAL_INFORMATION: 'Yderligere information',
  BACK: 'Tilbage',
  PREVIOUS: 'Forrige',
  CONTINUE_TO_SUMMARY: 'Fortsæt til resumé',
  CONTINUE: 'Fortsæt',
  ORDER_SUMMARY: 'Ordreoversigt',
  ORDER_SUMMARY_SUBTOTAL: 'Gennemgå dine ordredetaljer',
  YOUR_ITEMS: 'Dine varer',
  YOUR_ORDER: 'Din bestilling',
  CLOSE: 'Luk',
  TOTAL_AMOUNT: 'Samlet beløb',
  DELIVERY_INFORMATION: 'Leveringsinformation',
  DELIVERY_METHOD: 'Leveringsmetode',
  NAME: 'Navn',
  CREATED: 'Oprettet',
  EMAIL: 'E-mail',
  USER_ID: 'Bruger-ID',
  PHONE: 'Telefon',
  ADDRESS: 'Adresse',
  RESTAURANT_INFO: 'Restaurantinformation',
  COMPANY_NAME: 'Firmanavn',
  PROCEED_TO_PAYMENT: 'Gå videre til betaling',
  PAYMENT_METHOD: 'Betalingsmetode',
  SELECT_PAYMENT_METHOD: 'Vælg betalingsmetode',
  PAYMENT_METHOD_DESCRIPTION: 'Vælg dit foretrukne betalingsalternativ',
  CREDIT_CARD: 'Kreditkort',
  CREDIT_CARD_DESCRIPTION: 'Betal sikkert med kort',
  INVOICE: 'Faktura',
  INVOICE_DESCRIPTION: 'Betal senere via faktura',
  CASH: 'Kontant',
  CASH_DESCRIPTION: 'Betal ved levering/afhentning',
  CONFIRM_ORDER: 'Bekræft betaling',
  ORDER_PLACED: 'Ordre placeret!',
  SUCCESS_TEXT_1:
    'Din ordre er blevet placeret med succes. Vi sender dig en bekræftelsesmail kort tid efter.',
  SUCCESS_TEXT_2:
    'Efter at have gennemført betalingscheckout-sessionen, vil du modtage en ordrebekræftelsesmail. Tjek din e-mail for fremtidige ordreopdateringer.',
  PAYMENT_REQUIRED: 'Betaling påkrævet',
  INCOMPLETE_ORDER: 'Ufuldstændig ordre',
  KEEP_SHOPPING: 'Fortsæt med at handle',
  CANCEL_CHECKOUT_PROMPT: 'Er du sikker på, at du vil annullere checkout?',
  CONFIRMATION: 'Bekræftelse',
  CANCEL: 'Annuller',
  YES: 'Ja',
  TOTAL_PRICE_IS_0: 'Totalpris er 0',
  PLEASE_ADD_ITEMS_TO_CART: 'Tilføj venligst varer til kurven',
  ITEM: 'Vare',
  ITEMS: 'Varer',
  EMPTY_CART: 'Din kurv er tom',
  ADD_SOME_ITEMS: 'Tilføj nogle varer for at komme i gang!',
  SHOPPING_CART: 'Indkøbskurv',
  CLEAR_CART: 'Ryd kurv',
  CLEAR_CART_WARNING: 'Er du sikker på, at du vil rydde kurven?',
  CLEAR_CART_YES: 'Ryd kurv',
  CLEAR_CART_NO: 'Ryd ikke kurv',
  CART_ITEMS_NOT_AVAILABLE_FOR_SELECTED_DATE: 'Nogle varer i din kurv er ikke tilgængelige til den valgte leveringsdato. Du kan fjerne dem selv eller fortsætte.',
  NOT_AVAILABLE_FOR_DATE: 'Ikke tilgængelig på valgt dato',
  CLEAR: 'Ryd',
  SUBTOTAL: 'Subtotal',
  TOTAL_ITEMS: 'Samlet antal varer',
  TOTAL: 'I alt',
  VAT: 'moms',
  CHECKOUT: 'Til kassen',
  CONTACT: 'Kontakt',
  LOCATION: 'Lokation',
  Mobile_Pay_DESCRIPTION: 'Betal sikkert med mobile pay',
  Mobile_Pay: 'MobilePay',
  CONTINUE_SHOPPING: 'Fortsæt med at handle',
  QUANTITY: 'Antal',
  LANGUAGE: 'Sprog',
  SELECT_LANGUAGE: 'Vælg sprog',
  CURRENT: 'Nuværende',
  NO_LANGUAGES_FOUND: 'Ingen sprog fundet',
  TRY_DIFFERENT_SEARCH: 'Prøv en anden søgeterm',
  CHOOSE_A_DATE: 'Vælg en dato',
  CHOOSE_A_TIME: 'Vælg et tidspunkt',
  SELECT_PICKUP_TIME: 'Vælg afhentningstid',
  COMPANY_NAME_OPTIONAL: 'Firmanavn (valgfrit)',
  LOCATION_NAME_OPTIONAL: 'Stednavn (valgfrit)',
  ENTER_STREET_ADDRESS: 'Indtast gadeadresse',
  ENTER_CITY: 'Indtast by',
  ENTER_POSTAL_CODE: 'Indtast postnummer',
  FLOOR_NUMBER_OPTIONAL: 'Etagenummer (valgfrit)',
  ROOM_NUMBER_OPTIONAL: 'Rumsnummer (valgfrit)',
  ACCESS_CODE_OPTIONAL: 'Adgangskode (valgfrit)',
  ENTER_FIRST_NAME: 'Indtast dit fornavn',
  ENTER_LAST_NAME: 'Indtast dit efternavn',
  ENTER_EMAIL: 'Indtast din e-mailadresse',
  ENTER_ADDRESS: 'Indtast din adresse',
  EMAIL_REQUIRED: 'E-mailadresse er påkrævet.',
  EMAIL_INVALID: 'Indtast venligst en gyldig e-mailadresse.',
  SUCCESS: 'Succes',
  ERROR: 'Fejl',
  SAVING: 'Gemmer…',
  SET_PASSWORD_TITLE: 'Angiv din adgangskode',
  SET_PASSWORD_FOR_ACCOUNT: 'For konto:',
  SET_PASSWORD_SUBTITLE: 'Angiv en ny adgangskode til din konto.',
  NEW_PASSWORD: 'Ny adgangskode',
  CONFIRM_NEW_PASSWORD: 'Bekræft ny adgangskode',
  SAVE_PASSWORD: 'Gem adgangskode',
  PROCESSING_LINK: 'Behandler link…',
  RESET_LINK_INVALID: 'Linket til nulstilling af adgangskode er ugyldigt eller udløbet.',
  FILL_BOTH_PASSWORD_FIELDS: 'Udfyld begge adgangskodefelter.',
  PASSWORDS_DO_NOT_MATCH: 'Adgangskoderne matcher ikke.',
  PASSWORD_TOO_SHORT: 'Adgangskoden skal være mindst 6 tecken.',
  PASSWORD_RESET_SUCCESS: 'Adgangskoden er nulstillet.',
  PASSWORD_RESET_FAILED: 'Kunne ikke nulstille adgangskode. Prøv igen.',
  LOGIN_SUCCESS: 'Du er nu logget ind.',
  DELIVERY_OPTIONS_UNLOCKED: 'Leveringsmuligheder er nu tilgængelige.',
  LOGIN_INVALID_CREDENTIALS: 'Ugyldig e-mail eller adgangskode.',
  AUTH_EMAIL_MISSING_AT: "Indtast venligst et '@' i din e-mailadresse.",
  LOGIN_FAILED: 'Login mislykkedes. Prøv igen.',
  ACCOUNT_CREATED_SUCCESS: 'Konto oprettet.',
  ACCOUNT_CREATED_FAILED: 'Kunne ikke oprette konto.',
  ACCOUNT_ALREADY_EXISTS_ON_THIS_MAIL: 'Kontoen findes allerede på denne e-mail.',
  OKAY: 'Okay',
  ADD_TO_CART_HEADER: 'Tilføj til kurv',
  PER_UNIT: 'pr. enhed',
  QUANTITY_LABEL: 'Antal (min. {{min}})',
  MIN_ORDER_QUANTITY: 'Minimumsbestilling',
  MAX_ORDER_QUANTITY: 'Maksimumsbestilling',
  UNITS: 'stk.',
  PICKUP_TIME: 'Afhentningstid',
  DELIVERY_TIME: 'Leveringstid',
  DELIVERY_DATE: 'Leveringsdato',
  PICKUP_DATE: 'Afhentningsdato',
  ORDER_TYPE: 'Ordretype',
  HOME_DATE_SELECTION_UNAVAILABLE_TITLE: 'Ingen serveringsmetoder tilgængelige',
  HOME_DATE_SELECTION_UNAVAILABLE_DESCRIPTION: 'Denne restaurant accepterer i øjeblikket ikke afhentnings- eller leveringsbestillinger.',
  HOME_DATE_SELECTION_UNAVAILABLE_NOTE: 'Accepterer ikke bestillinger i øjeblikket',
  SELECT_DELIVERY_DATE: 'Vælg leveringsdato',
  SELECT_DELIVERY_AND_DATE: 'Levering & dato',
  SELECT_ORDER_DATE: 'Leveringsmetode og dato',
  CONTINUE_WITHOUT_DATE: 'Fortsæt uden dato',
  SELECT_WEEKDAY: 'Vælg mellem afhentning eller erhvervslevering og angiv ønsket dato',
  JUST_BROWSING: 'Kigger bare',
  CONFIRM: 'Bekræft',
  PRICE: 'Pris',
  PRODUCT_DESCRIPTION: 'Produktbeskrivelse',
  READ_MORE: 'Læs mere',
  READ_LESS: 'Læs mindre',
  SERVINGS_PER_PRODUCT: 'Portioner pr. produkt',
  RETURN_TO_HOME: 'Tilbage til hjem',
  ORDER_FAILED: 'Ordre mislykkedes',
  MAXIMUM_ORDER_QUANTITY: 'Maksimum',
  MINIMUM_ORDER_QUANTITY: 'Minimum',
  LOCATION_FOOTER: 'Adresse',
  INFO_FOOTER: 'Mere information',
  HOSTED_BY_PUBQ: 'Hostet af PubQ AB',
  TERMS_OF_SERVICE: 'Servicevilkår',
  NO_PRODUCTS_AVAILABLE: 'Ingen produkter tilgængelige',
  CHECK_BACK_SOON_CATEGORY: 'Tjek tilbage snart for nye varer i denne kategori',
  NO_CATEGORIES_AVAILABLE: 'Ingen kategorier tilgængelige',
  CHECK_BACK_LATER: 'Tjek tilbage senere for opdateringer!',
  NO_MENU_AVAILABLE: 'Ingen menu tilgængelig',
  MENU_UPDATING_MESSAGE:
    'Vi opdaterer i øjeblikket vores menu. Tjek venligst tilbage snart for vores lækre tilbud!',
  REFRESH_PAGE: 'Opdater side',
  CONTACT_US: 'Kontakt os',
  READ_TERMS: 'Jeg har læst vilkårene for brug',
  ACCEPT_PURCHASE_TERMS_PREFIX: 'Ved at gennemføre dette køb accepterer du vores ',
  TERMS_AND_CONDITIONS: 'Vilkår og betingelser',
  ACCEPT_PURCHASE_TERMS_AND: ' og ',
  PRIVACY_POLICY: 'Privatlivspolitik',
  NO_PRODUCTS_IN_CATEGORY: 'Ingen produkter i denne kategori',
  NO_PRODUCTS_MATCH_FILTERS: 'Ingen produkter matcher dine valgte filtre.',
  PRODUCTS_COMING_SOON: 'Produkter kommer snart!',
  MOVE_TO_CAMPAIGN_MENU: 'Flyt til kampagne',
  CLOSE_CART: 'Luk kurv',
  TIME_SLOT_NOT_SELECTED: 'Tidslot ikke valgt',
  SEE_MORE: 'Se mere',
  SOON_BACK_IN_STOCK: 'Snart tilbage på lager',
  FEW_LEFT_IN_STOCK: 'Få tilbage på lager',
  OUT_OF_STOCK: 'Udsolgt',
  QUANTITY_EXCEEDS_STOCK: 'Antal overstiger tilgængelig beholdning. Kun {{0}} tilgængelige.',
  INACTIVE: 'Inaktiv',
  CURRENTLY_UNAVAILABLE: 'I øjeblikket ikke tilgængelig',
  PREPARATION_DAYS_REQUIRED: 'Forberedelsesdage påkrævet',
  DAYS: 'Dage',
  AVAILABLE: 'Tilgængelig',
  AVAILABLE_PICKUP_DATES: 'Tilgængelige afhentningsdatoer',
  CONTENTS_AND_ALLERGENS: 'Indhold og allergener',
  SIMILAR_PRODUCTS: 'Lignende produkter',
  MILK: '🥛 Mælk',
  MILK_PROTEIN: '🥛 Mælkeprotein',
  GLUTEN: '🌾 Gluten',
  NUTS: '🥜 Nødder',
  CRUSTACEANS: '🦞 Skaldyr',
  EGG: '🥚 Æg',
  MOLLUSCS: '🦪 Bløddyr',
  FISH: '🐟 Fisk',
  PORK: '🥓 Svinekød',
  PEANUTS: '🥜 Jordnødder',
  SESAME_SEEDS: 'Sesamfrø',
  SULPHUR: 'Svovl',
  SOYBEANS: '🫘 Sojabønner',
  CELERY: '🥬 Selleri',
  MUSTARD: 'Sennep',
  LUPIN: 'Lupin',
  GARLIC: '🧄 Hvidløg',
  MUSHROOM: '🍄‍🟫 Svamp',
  ALMOND: '🥜 Mandel',
  HAZELNUT: '🥜 Hasselnød',
  WALNUT: '🥜 Valnød',
  CASHEW: '🥜 Cashewnød',
  PECAN: '🥜 Pecannød',
  BRAZIL_NUT: '🥜 Paranød',
  PISTACHIO: '🥜 Pistacienød',
  MACADAMIA: '🥜 Macadamianød',
  DESCRIPTION: 'Beskrivelse',
  ADDONS: 'Tilbehør',
  ADDON_PICK_ONE: 'Vælg én',
  ADDON_REQUIRED: 'Påkrævet',
  ADDON_OPTIONAL: 'Valgfrit',
  ADDON_MIN: 'Min',
  ADDON_MAX: 'Max',
  ADDON_UNAVAILABLE: 'Ikke tilgængelig',
  ADDON_SHOW_LESS: 'Vis færre',
  ADDON_SHOW_FEWER_GROUPS: 'Vis færre grupper',
  // Success page translations
  ORDER_CONFIRMED: 'Ordre bekræftet!',
  ORDER_NUMBER_LABEL: 'Ordre #',
  PAYMENT_PROCESSED: 'Betaling behandlet',
  PAYMENT_CONFIRMED: 'Din betaling er blevet bekræftet',
  EMAIL_SENT: 'E-mail sendt',
  EMAIL_CONFIRMATION_SENT: 'Bekræftelse sendt til din indbakke',
  ORDER_PROCESSING: 'Ordre behandles',
  ORDER_PREPARING: 'Restauranten forbereder din ordre',
  BACK_TO_HOME: 'Tilbage til hjem',
  // Failure page translations
  PAYMENT_FAILED: 'Betaling mislykkedes',
  PAYMENT_DECLINED: 'Betaling afvist',
  PAYMENT_METHOD_DECLINED: 'Din betalingsmetode blev afvist',
  WHAT_TO_DO_NEXT: 'Hvad skal du gøre nu?',
  VERIFY_PAYMENT_AND_RETRY: 'Verificer dine betalingsoplysninger og prøv igen',
  HOME: 'Hjem',
  MAXIMUM_REACHED: 'Maksimum nået',
  SEARCH_TEXT: 'Søg...',
  IMPORTANT_INFORMATION: 'Vigtig information',
  DIFFERENT_PRODUCTION_TIMES_WARNING: 'Den tidligste leveringsdato fastsættes ud fra produktet med den længste produktionstid.',
  GOOGLE_PAY: 'Google Pay',
  GOOGLE_PAY_DESCRIPTION: 'Betal sikkert med Google Pay',
  APPLE_PAY: 'Apple Pay',
  APPLE_PAY_DESCRIPTION: 'Betal sikkert med Apple Pay',
  SWISH: 'Swish',
  SWISH_DESCRIPTION: 'Betal sikkert med Swish',
  COMPLETE_SWISH_PAYMENT: 'Fuldfør Swish-betaling',
  SELECT_WHERE_TO_OPEN_SWISH: 'Vælg hvor du vil åbne Swish',
  LAUNCHES_SWISH_APP: 'Starter Swish-appen',
  SCAN_QR_CODE: 'Scan QR-kode',
  CANCEL_PAYMENT: 'Annuller betaling',
  // Swish payment component
  SWISH_CHOOSE_HOW_TO_PAY: 'Vælg hvordan du vil betale',
  SWISH_SUBTITLE: 'Brug Swish på denne enhed eller på en anden enhed.',
  SWISH_PAY_ON_THIS_DEVICE: 'Betal på denne enhed',
  SWISH_PAY_ON_OTHER_DEVICE: 'Betal på anden enhed',
  SWISH_SCAN_QR_CODE: 'Scan QR-koden med Swish for at betale',
  PAYMENT_DEVICE_NOT_SUPPORTED: 'Denne enhed understøtter ikke Swish-betalinger',
  SWISH_OPEN_ON_PHONE: 'Åbn Swish på din telefon for at betale',
  SWISH_OPEN_APP: 'Åbn Swish',
  SWISH_PAYMENT_SUCCESS: 'Betaling gennemført',
  SWISH_PAYMENT_FAILED: 'Betaling mislykkedes',
  SWISH_PAYMENT_ERROR: 'Fejl under behandling af betaling.',
  SWISH_PAYMENT_CANCELLED_INFO:
    'Betalingen blev annulleret i Swish. Opdater bestillingen om nødvendigt, og brug derefter den samme Swish-knap igen for at få en ny QR-kode.',
  SWISH_VERIFY_TIMEOUT: 'Swish-betalingen fik timeout',
  BACK_TO_CHECKOUT: 'Tilbage til checkout',
  EARLIEST_DELIVERY_DATE: 'Tidligst leveringsdato',
  EARLIEST_POSSIBLE_DELIVERY_DATE_IS: 'Tidligste leveringsdato',
  AVAILABLE_FROM: 'Tilgængelig fra',
  DELIVERY_LOCATIONS: 'Leveringssteder',
  CORPORATE_DELIVERY_LOCATIONS: 'Leveringssteder for denne virksomhed',
  NO_CORPORATE_CUSTOMERS: 'Ingen firmakunder tilgængelige',
  COMPANY: 'Virksomhed',
  ENTRANCE_CODE: 'Adgangskode',
  DEFAULT_REFERENCE: 'Standard reference',
  SPECIFIC_LOCATION: 'Specifik adresse',
  SELECT_LOCATION: 'Vælg adresse',
  VIEW_ALL_DELIVERY_LOCATIONS: 'Vis alle leveringssteder',
  CHANGE: 'Skift',
  SELECT: 'Vælg',
  INVOICE_INFORMATION: 'Fakturaoplysninger',
  INVOICE_ADDRESS: 'Fakturaadresse',
  ORGANIZATION_NUMBER: 'Organisationsnummer',
  VAT_NUMBER: 'Momsnummer',
  COST_CENTER: 'Omkostningssted',
  SELECT_DELIVERY_TIME: 'Vælg leveringstid',
  // Login dialog
  LOGIN_TO_YOUR_ACCOUNT: 'Log ind på din konto',
  LOGIN_SUBTITLE: 'Log ind for at administrere dine cateringbestillinger og få adgang til firmacatering',
  LOGIN_EMAIL_PLACEHOLDER: 'example@email.com',
  PASSWORD: 'Adgangskode',
  FORGOT_PASSWORD: 'Glemt adgangskode?',
  LOGIN_PASSWORD_PLACEHOLDER: 'Indtast din adgangskode',
  LOGIN: 'Log ind',
  CREATE_NEW_ACCOUNT: 'Opret ny konto',
  OR_CONTINUE_WITH: 'Eller fortsæt med',
  CONTINUE_WITH_GOOGLE: 'Fortsæt med Google',
  CONTINUE_WITH_MICROSOFT: 'Fortsæt med Microsoft',
  CONTINUE_WITH_APPLE: 'Fortsæt med Apple',
  CREATE_YOUR_ACCOUNT: 'Opret din konto',
  CREATE_ACCOUNT_SUBTITLE: 'Tilmeld dig for at få adgang til virksomhedens leveringsmuligheder',
  BACK_TO_LOGIN: 'Tilbage til login',
  CONFIRM_PASSWORD: 'Bekræft adgangskode',
  PASSWORD_REQUIREMENTS: 'Adgangskoden skal være mindst 6 tegn.',
  CREATE_ACCOUNT: 'Opret konto',
  OR_SIGN_UP_WITH: 'Eller tilmeld dig med',
  BACK_TO_STORE: 'Tilbage til butiken',
  CONTINUE_CHECKOUT: 'Fortsæt med købet',
  MY_ACCOUNT: 'Min konto',
  MY_PAGE: 'Min side',
  ACCOUNT_INFORMATION: 'Mine oplysninger',
  EDIT: 'Rediger',
  ADD: 'Tilføj',
  LOGOUT: 'Log ud',
  LOGOUT_SUCCESS: 'Du er blevet logget ud.',
  ACTIVE_ORDERS: 'Aktive ordrer',
  PREVIOUS_ORDERS: 'Tidligere ordrer',
  ORDER_STATUS: 'Status',
  ORDER_NUMBER: 'Ordre',
  DECLINED: 'Afvist',
  COMPLETED: 'Færdig',
  DONE: 'Færdig',
  RECEIPTS: 'Kvitteringer',
  NO_ORDERS_YET: 'Ingen ordrer endnu',
  NO_ACTIVE_ORDERS_YET: 'Ingen aktive ordrer',
  NO_ACTIVE_ORDERS_SUBTITLE: 'Ordre du har lagt vises her, mens de forberedes.',
  NO_PREVIOUS_ORDERS_YET: 'Ingen tidligere ordrer',
  NO_PREVIOUS_ORDERS_SUBTITLE: 'Fuldførte eller afviste ordrer fra den sidste måned vises her.',
  NO_RECEIPTS_YET: 'Ingen kvitteringer endnu',
  NO_RECEIPTS_SUBTITLE: 'Kvitteringer for dine ordrer vises her.',
  NO_CORPORATE_COMPANY_CONNECTED: 'Intet virksomhed tilsluttet',
  NO_CORPORATE_COMPANY_SUBTITLE: 'Tilslut en virksomhedskonto for at bestille levering til din arbejdsplads.',
  WANT_DELIVERY_TO_YOUR_COMPANY: 'Vil du have levering til din virksomhed?',
  DELIVERY_TO_COMPANY: 'Virksomhedslevering',
  DELIVERY_NOT_AVAILABLE_NO_COMPANY: 'Levering ikke tilgængelig',
  DELIVERY_NOT_AVAILABLE_NO_COMPANY_DESCRIPTION: 'Du har ikke adgang til firmacatering',
  NO_SERVING_METHODS_AVAILABLE: 'Ingen serveringsmetoder tilgængelige',
  NO_SERVING_METHODS_AVAILABLE_DESCRIPTION: 'Denne restaurant accepterer i øjeblikket ikke afhentnings- eller leveringsbestillinger.',
  CREATE_ACCOUNT_OR_LOGIN: 'Opret en konto eller log ind',
  ENTER_PHONE: 'Indtast telefonnummer',
  CURRENT_PASSWORD: 'Nuværende adgangskode',
  ENTER_CURRENT_PASSWORD: 'Indtast nuværende adgangskode',
  SAVE: 'Gem',
  // Account receipts
  CLIENT_INFORMATION: 'Kundeoplysninger',
  VAT_ID: 'CVR/VAT-nummer',
  RECEIPT: 'Kvittering',
  RECEIPT_NUMBER: 'Kvitteringsnummer',
  DATE: 'Dato',
  PRODUCTS: 'Produkter',
  PRODUCT: 'Produkt',
  DISCOUNT: 'Rabat',
  // Forgot password page
  FORGOT_PASSWORD_TITLE: 'Glemt din adgangskode?',
  FORGOT_PASSWORD_SUBTITLE: 'Indtast din e-mailadresse for at modtage et link til nulstilling af adgangskode.',
  FORGOT_PASSWORD_EMAIL_PLACEHOLDER: 'Indtast din e-mailadresse',
  FORGOT_PASSWORD_SUBMIT: 'Send nulstillingslink',
  FORGOT_PASSWORD_BACK: 'Tilbage til login',
  FORGOT_PASSWORD_EMAIL_SENT: 'Et link til nulstilling af adgangskode er sendt til din e-mail.',
  FORGOT_PASSWORD_FAILED: 'Kunne ikke sende nulstillingsmail. Prøv igen.',
  FORGOT_PASSWORD_INVALID_EMAIL: 'Indtast venligst en gyldig e-mailadresse.',
  GO_BACK: 'Gå tilbage',
  SUBMIT: 'Indsend',
  //Home-panel translations
  CATEGORIES: 'Kategorier',
  DIETARY_OPTIONS: 'Diætetiske muligheder',
  SAVED_CARDS: 'Gemte betalingskort',
  COMING_SOON: 'Kommer snart',
  ORDERS: 'Ordrer',
  SHOW_MORE: 'Vis mere',
  SHOW_LESS: 'Vis mindre',
  APPLY_FILTER: 'Anvend filter',
  START_DATE: 'Startdato',
  END_DATE: 'Slutdato',
  FILTER_RESULT: 'Filterresultat',
  TOTAL_ACTIVE_ORDERS: 'Samlet aktive ordrer',
  TOTAL_PREVIOUS_ORDERS: 'Samlede tidligere ordrer',
  TOTAL_SAVED_RECEIPTS: 'Samlede gemte kvitteringer',
  CARD_DETAILS: 'Kortoplysninger',
  ALL: 'Alle',
  CARD: 'Kort',
  REMOVE_CARD: 'Fjern kort',
  REMOVE_CARD_TITLE: 'Fjern gemt kort?',
  REMOVE_CARD_WARNING: 'Dette kort vil blive fjernet permanent fra alle PubQ-systemer — inklusive mobilappen, webbestilling og alle andre PubQ-platforme. Denne handling kan ikke fortrydes.',
  REMOVE_CARD_CONFIRM: 'Ja, fjern kort',
  REMOVE_CARD_FAILED: 'Kunne ikke fjerne kortet. Prøv igen.',
  REMOVING_CARD: 'Fjerner…',
  SELECT_BOTH_START_END_DATES: 'Vælg både start- og slutdato.',
  START_DATE_MUST_BE_BEFORE_END_DATE: 'Startdato skal være før slutdato.',
  CATERING_PENDING: 'Afventer',
  APPROVED: 'Godkendt',
  COUPON: 'Rabatter',
  APPLY_DISCOUNT: 'Anvend rabat',
  COUPON_CODE: 'Rabatkode',
  HAVE_A_COUPON_CODE: 'Har du en rabatkode?',
  USE_COUPON_CODE: 'Brug din rabatkode',
  ENTER_YOUR_CODE_BELOW: 'Indtast din kode nedenfor',
  ENTER_YOUR_CODE_HERE: 'Indtast din kode',
  APPLY: 'Anvend',
  REMOVE: 'Fjern',
  TOTAL_DISCOUNT: 'Total rabat',
  INVALID_COUPON: 'Ugyldig kode',
  CHECKING_DISCOUNT_CODE: 'Tjekker kode…',
  APPLIED_DISCOUNT: 'Rabat anvendt',
  UNEXPECTED_ERROR: 'Der opstod en uventet fejl.',
  UNEXPECTED_ERROR_TRY_AGAIN: 'Der opstod en uventet fejl. Prøv igen.',
  PLEASE_FILL_REQUIRED_FIELDS: 'Udfyld venligst alle obligatoriske felter',
  EACH: 'stk.',
  TOTAL_ITEMS_PRODUCT_PAGE: 'Varor',
  ONLY_ONE_SERVING_METHOD_AVAILABLE: 'Valg af dato',
  SELECT_WEEKDAY_SINGLE_METHOD: 'Hvornår vil du modtage din ordre?',
  POWERED_BY: 'Leveret af',
  FROM: 'Fra',
  EX_VAT: 'ekskl. moms',
  OF_WHICH_VAT: 'heraf moms',
  VAT_AMOUNT: 'Moms',
  TOTAL_INC_VAT: 'I alt inkl. moms',
  NO_COST: 'Ingen omkostning',

  // --- Guest "order by invoice" checkout (no login) ---
  GUEST_INVOICE_TITLE: "Bestil mod faktura",
  DELIVERY_GUEST_INVOICE: "Levering / bestil mod faktura",
  GUEST_INVOICE_DESCRIPTION: "Ingen konto nødvendig — vi fakturerer din virksomhed",
  GUEST_INVOICE_EVENT_SECTION: "Oplysninger om arrangementet",
  GUEST_INVOICE_EVENT_SECTION_DESCRIPTION: "Fortæl os, hvilket møde cateringen er til.",
  GUEST_INVOICE_BILLING_SECTION: "Virksomheds- og faktureringsoplysninger",
  GUEST_INVOICE_BILLING_SECTION_DESCRIPTION: "Fakturaen sendes til disse oplysninger. Der trækkes ingen betaling nu.",
  MEETING_ROOM_NAME: "Mødelokalets navn",
  MEETING_ROOM_NAME_PLACEHOLDER: "f.eks. Mødelokale Aurora",
  NUMBER_OF_ATTENDEES: "Antal personer",
  EVENT_HOST: "Vært for arrangementet",
  EVENT_END_TIME: "Arrangementet slutter (valgfrit)",
  SPECIAL_DIETS: "Specialkost",
  SPECIAL_DIETS_PLACEHOLDER: "f.eks. 2 glutenfri, 1 vegansk",
  PARTICIPANT_LIST: "Deltagerliste",
  PARTICIPANT_LIST_PLACEHOLDER: "Deltagernes navne (valgfrit)",
  INVOICE_REFERENCE: "Referenceoplysninger",
  INVOICE_REFERENCE_PLACEHOLDER: "f.eks. projekt- eller referencenummer",
  INVOICE_EMAIL: "Faktura-e-mail",
  INVOICE_NO_PAYMENT_TAKEN: "Ingen betaling trukket",
  INVOICE_WILL_FOLLOW: "Der er ikke trukket noget. En faktura sendes til de faktureringsoplysninger, du har angivet.",
  ORDER_TERMS_TITLE: "Bestillingsbetingelser",
  ORDER_TERMS_BODY: "Bestillingen er bindende. Ændringer og afbestillinger skal ske senest to (2) hverdage før arrangementet; senere afbestillinger faktureres fuldt ud. Det antal personer, der er bekræftet ved bestilling, danner grundlag for faktureringen. Betalingsbetingelser 14 dage netto.",

  // --- Partner group restaurant picker (/g/:slug) ---
  PARTNER_CHOOSE_RESTAURANT: "Vælg restaurant",
  PARTNER_CHOOSE_RESTAURANT_HINT: "Vælg hvor du vil bestille din catering fra.",
  PARTNER_ORDER_FROM_HERE: "Bestil",
  PARTNER_GROUP_NOT_FOUND: "Siden blev ikke fundet",
  PARTNER_GROUP_NOT_FOUND_DESCRIPTION: "Dette link til restaurantgruppen er ikke tilgængeligt. Tjek linket og prøv igen.",
};
